function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { P, GridRow, Icon } from "../../";
export const FieldMessage = ({
  content = "",
  type = "error",
  active = true,
  ...props
}) => {
  let color = type === "error" ? "red" : "green";
  return active && /*#__PURE__*/React.createElement(ErrorMessageContainer, _extends({
    yCenter: true
  }, props), type === "error" && /*#__PURE__*/React.createElement(ErrorIcon, {
    form: true,
    name: "Error"
  }), type === "success" && /*#__PURE__*/React.createElement(SuccessIcon, {
    badge: true,
    name: "FacebookVerified"
  }), /*#__PURE__*/React.createElement(Message, {
    color: color
  }, content));
};
const ErrorMessageContainer = styled(GridRow)`
  margin-top: 11px;
`;
const Message = styled(P)`
  color: ${props => props.theme.palette[props.color].primary};
  font-size: 15px;
`;
const ErrorIcon = styled(Icon)`
  display: inline-flex;
  flex-shrink: 0;
  margin-right: 12px;
  position: relative;
  width: 16px;
  @media only screen and ${props => props.theme.media.small} {
    display: none;
  }
`;
const SuccessIcon = styled(ErrorIcon)`
  margin-right: 8px;
  path {
    fill: ${props => props.theme.palette.green.primary};
  }
  @media only screen and ${props => props.theme.media.small} {
    display: block;
  }
`;